import cnFlag from "../assets/flags/cn.png";
import ukFlag from "../assets/flags/gb.png";
import irFlag from "../assets/flags/ir.png";
import saFlag from "../assets/flags/sa.png";

import zod_ar from "../i18n/zod/ar-SA.json";
import zod_en from "../i18n/zod/en.json";
import zod_fa from "../i18n/zod/fa.json";
import zod_zh from "../i18n/zod/zh-CN.json";

import type { GridLocaleText } from "@mui/x-data-grid";
import { arSD, enUS, faIR, zhCN } from "@mui/x-data-grid/locales";

export type TextDirection = "ltr" | "rtl";

interface ZodMessages {
	errors: Record<string, any>;
	validations: Record<string, any>;
	types: Record<string, any>;
}

export interface LanguageData {
	code: Language;
	name: string;
	flag: string;
	mode: TextDirection;
	zodPath: ZodMessages;
	dataTableLocale: Partial<GridLocaleText>;
}

export const LANGUAGES = {
	en: {
		code: "en",
		name: "English",
		flag: ukFlag,
		mode: "ltr",
		zodPath: zod_en,
		dataTableLocale: enUS.components.MuiDataGrid.defaultProps.localeText,
	},
	"ar-SA": {
		code: "ar-SA",
		name: "Arabic",
		flag: saFlag,
		mode: "rtl",
		zodPath: zod_ar,
		dataTableLocale: arSD.components.MuiDataGrid.defaultProps.localeText,
	},
	fa: {
		code: "fa",
		name: "Persian",
		flag: irFlag,
		mode: "rtl",
		zodPath: zod_fa,
		dataTableLocale: faIR.components.MuiDataGrid.defaultProps.localeText,
	},
	"zh-CN": {
		code: "zh-CN",
		name: "Chinese",
		flag: cnFlag,
		mode: "ltr",
		zodPath: zod_zh,
		dataTableLocale: zhCN.components.MuiDataGrid.defaultProps.localeText,
	},
} as const;

export type Language = keyof typeof LANGUAGES;

export const LANGUAGE_KEYS = Object.keys(LANGUAGES) as Language[];
